import Snaker, { Options } from '../index'
import createWebClick from './webClick'

interface UsualPluginOptions extends Options {
  webClick: boolean
}

export default {
  install(pluginOptions: UsualPluginOptions) {
    const { webClick = false, ...options } = pluginOptions
    const snaker = new Snaker(options)

    document.addEventListener('DOMContentLoaded', () => {
      snaker.trackAsync('pageView', location.pathname, location.pathname)
    })

    if (webClick) {
      const instance = createWebClick(snaker)
      instance.start()
    }

    return snaker
  }
}
